import { ReactNode } from 'react';

import { styled } from '@mui/material';

import { Skeleton } from '@app-velocity/ui';

import { Page } from '../Page/Page';
import { PageHeader } from '../../components/PageHeader';
import { PageFooter } from '../../components/PageFooter';

export type PageWithBackHeaderProps = {
  children: ReactNode;
  title: ReactNode | undefined;
  to?: string;
  secondaryTitle?: string;
  footer?: ReactNode;
};

const Content = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
});

export const PageWithBackHeader = ({
  children,
  to,
  title,
  secondaryTitle,
  footer,
}: PageWithBackHeaderProps) => {
  return (
    <>
      <PageHeader>
        <PageHeader.Back
          to={to}
          title={title || <Skeleton width={80} height={20} borderRadius={2} />}
          secondaryTitle={secondaryTitle}
        />
      </PageHeader>
      <Page>
        {/* additional div for correct scroll behavior */}
        <Content>{children}</Content>
      </Page>
      {footer ? <PageFooter>{footer}</PageFooter> : null}
    </>
  );
};
